import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getScreenWidth, getScreenIsReady } from 'selectors/screen'
import {
  getAlgoliaDataPaginationCurrent,
  getAlgoliaDataPaginationTotal,
} from 'selectors/algolia2/data'
import { Actions } from '../actions'
import {
  findHitResult,
  getHitsPerPage,
  getHitsResults,
  getHitsTotal,
  getQueryId,
  getSort,
} from '../selectors/algolia'
import { getUserId } from '../selectors/url'
import { SAArtwork } from 'types/Artwork'

const mapStateToProps = createStructuredSelector({
  artworks: getHitsResults,
  getArtwork: (state, ownProps) => findHitResult(ownProps.artId)(state),
  hitsPerPage: getHitsPerPage,
  hitsTotal: getHitsTotal,
  isReady: getScreenIsReady,
  currentPage: getAlgoliaDataPaginationCurrent,
  totalPages: getAlgoliaDataPaginationTotal,
  queryId: getQueryId,
  userId: getUserId,
  screenWidth: getScreenWidth,
  sort: getSort,
})

const mapDispatchToProps = (dispatch) => ({
  updateHitsPerPage: (payload: number) => dispatch(Actions.UPDATE_HITS_PER_PAGE(payload)),
})

export type ConnectorProps = {
  artworks: ReadonlyArray<SAArtwork>
  getArtwork: Record<string, any>
  hitsPerPage: number
  hitsTotal: number
  isReady: boolean
  currentPage: number
  totalPages: number
  queryId: string
  userId: string
  sort: string
  screenWidth: number
  updateHitsPerPage: (...args: Array<any>) => any
}
export default connect(mapStateToProps, mapDispatchToProps) // Component Calls Connect
